import { render, staticRenderFns } from "./inmitCard.vue?vue&type=template&id=0a4cc661&scoped=true&"
import script from "./inmitCard.vue?vue&type=script&lang=js&"
export * from "./inmitCard.vue?vue&type=script&lang=js&"
import style0 from "./inmitCard.vue?vue&type=style&index=0&id=0a4cc661&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4cc661",
  null
  
)

export default component.exports